import React from 'react';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default function FolderPreset({ cache, title, disabled }) {
  const saved = cache.preset;
  const [label, setLabel] = React.useState('');
  React.useEffect(() => {
    setLabel(saved?.label || '');
  }, [saved?.label]);
  const handlePathChange = (event) => setLabel(event.target.value);
  const handlePathBlur = () => {
    const path = label.trim();
    setLabel(path);
    if (path !== (saved?.label || '')) cache.setLabel(path);
  };
  const handleReconnect = () => cache.reconnect();
  return (
    <Box
      sx={{
        p: 2,
        mb: 1,
        border: '1px solid',
        borderColor: 'primary.main',
        bgcolor: 'action.hover',
        borderRadius: 1,
      }}
    >
      <Typography variant="subtitle2">{title}</Typography>
      <Typography sx={{ fontWeight: 700, fontSize: '1.1rem', overflowWrap: 'anywhere' }}>
        {cache.restoring
          ? 'Restoring saved folder…'
          : saved?.label || saved?.directory.name || 'No folder selected'}
      </Typography>
      {saved && (
        <>
          <Typography variant="body2">
            {saved.entries.length.toLocaleString()} cached entries ·{' '}
            {cache.allowed ? 'Connected' : 'Reconnect required'} · Saved{' '}
            {new Date(saved.savedAt).toLocaleString()}
          </Typography>
          <TextField
            fullWidth
            size="small"
            sx={{ mt: 1 }}
            label="Full folder path"
            placeholder="C:\Users\jrlube\Downloads\hr_Study"
            value={label}
            disabled={disabled}
            onChange={handlePathChange}
            onBlur={handlePathBlur}
            helperText="Paste the full path from Windows File Explorer once. It is saved locally and shown above after you leave this field. The browser cannot read the full path; this display label does not change the selected folder."
          />
          {!cache.allowed && (
            <Button
              sx={{ mt: 1 }}
              variant="contained"
              disabled={disabled}
              onClick={handleReconnect}
            >
              Reconnect saved folder
            </Button>
          )}
        </>
      )}
      {cache.notice && (
        <Alert severity="info" sx={{ mt: 1 }}>
          {cache.notice}
        </Alert>
      )}
    </Box>
  );
}
